module.exports = "/assets/data/9e00c89d18ce82ae9df8158d315fa3d1-SE18.data.json";